<script setup lang="ts">
import type { IntakeAgentLogInDb } from '@/api';
import { computed, ref } from 'vue';

// Modal visibility
const visible = ref(false);

// Props
const props = defineProps<{
  logDetails: IntakeAgentLogInDb | null;
}>();

// Public methods
function show(): void {
  visible.value = true;
}

function hide(): void {
  visible.value = false;
}

// Expose methods for parent component
defineExpose({
  show,
  hide,
});

// Computed
const formattedJson = computed<string>(() => {
  if (!props.logDetails) return '';
  return JSON.stringify(props.logDetails, null, 2);
});
</script>

<template>
  <n-modal
    v-model:show="visible"
    style="width: 80%; max-width: 1000px"
    preset="card"
    title="Intake Agent Log Details"
    size="huge"
    :mask-closable="true"
  >
    <n-tabs type="line">
      <n-tab-pane name="json" tab="Raw JSON">
        <n-card>
          <pre style="max-height: 500px; overflow: auto">{{ formattedJson }}</pre>
        </n-card>
      </n-tab-pane>
    </n-tabs>

    <template #footer>
      <div style="display: flex; justify-content: flex-end">
        <n-button @click="hide">Close</n-button>
      </div>
    </template>
  </n-modal>
</template>
